import React, { Component } from "react";
import "../datepicker-overrides.scss";
import DatePicker from "@acadia-ui/datepicker";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import moment from "moment";

class DatePickerSingleV2 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			minDate: this.props.minDate,
			maxDate: this.props.maxDate,
			alignMenu: "start"
		};
	}

	componentDidMount = () => {
		if (this.props.configName === "ActivationPlatform" && !Number.isInteger(this.props.position / 3)) {
			const mod = ((this.props.position % 3) + 3) % 3;
			if (mod === 1) {
				this.setState({ alignMenu: "center" });
			} else if (mod === 2) {
				this.setState({ alignMenu: "end" });
			}
		}
	};

	handleChange = (locale) => {
		const momentDate = moment(locale);
		const month = momentDate.format("MM");
		const date = momentDate.format("DD");
		const year = momentDate.format("YYYY");
		const validDate = `${month}/${date}/${year}`;
		this.props.onDateChange(this.props.name, validDate, this.props.dataConfig, this.props.id);
	};

	ConvertToValidDateValue = (value) => {
		if (!value) {
			return null;
		}

		if (moment.isMoment(value)) {
			return value.isValid() ? value.clone().startOf("day").toDate() : null;
		}

		if (value instanceof Date) {
			return Number.isNaN(value.getTime()) ? null : new Date(value.getFullYear(), value.getMonth(), value.getDate());
		}

		const validDate = moment(value, [moment.ISO_8601, "MM/DD/YYYY", "YYYY/MM/DD"], true);
		return validDate.isValid() ? validDate.startOf("day").toDate() : null;
	};

	render() {
		return (
			<DatePicker
				className={`align-menu-to-${this.state.alignMenu}`}
				id={this.props.id}
				name={this.props.name}
				onChange={this.handleChange}
				minDate={this.ConvertToValidDateValue(this.state.minDate)}
				required={this.props.required}
				maxDate={this.ConvertToValidDateValue(this.state.maxDate)}
				// maxDate={
				// 	this.ConvertToValidDateValue(this.props.minDate) > this.ConvertToValidDateValue(this.props.maxDate)
				// 		? this.ConvertToValidDateValue(this.state.minDate)
				// 		: this.ConvertToValidDateValue(this.state.maxDate)
				// }
				dataconfig={this.props.dataConfig}
				// className="dp-margin"
				// disabled={this.props.value}
				value={this.ConvertToValidDateValue(this.props.value)}
				openOnClick={true}
			>
				{this.props.label}
				{this.props.fieldDescription && (
					<Tooltip className="field-description-tooltip" title={this.props.fieldDescription} position={TOOLTIP_POSITION.BOTTOM}>
						<i className="icon-info" />
					</Tooltip>
				)}
			</DatePicker>
		);
	}
}

export default DatePickerSingleV2;
